/* stylelint-disable selector-no-qualifying-type */
/* stylelint-disable property-no-vendor-prefix */

/*
* @prop --uic-scrollpanel-background-color: The background color of the entire scroll panel.
* @prop --uic-scrollpanel-indicator-color: The color of the line indicating the track.
* @prop --uic-scrollpanel-track-width: The width of the the track.
* @prop --uic-scrollpanel-track-spacing: The margin on each side of the track. Affects the interactable area.
* @prop --uic-scrollpanel-bar-color: The color of the bar inside the track.
*/

uic-scrollpanel {
  background-color: var(--uic-scrollpanel-background-color);
  display: block;
  overflow-x: hidden;

  .track-indicator {
    background: var(--uic-scrollpanel-indicator-color);
    bottom: 0;
    left: 50%;
    position: absolute;
    top: 0;
    width: 1px;
  }

  // ADJUSTMENTS TO SIMPLEBAR CSS

  .simplebar-track {
    opacity: 0;
    transition: opacity 0.2s 1s linear;
  }

  &.uic-scrollpanel--scrollbar-auto-hide-disabled .simplebar-track {
    opacity: 1;
    transition: none;
  }

  .simplebar-track.simplebar-vertical {
    bottom: calc(var(--uic-scrollpanel-track-spacing) + 8px);
    overflow: visible;
    pointer-events: visible;
    right: 0;
    top: calc(var(--uic-scrollpanel-track-spacing) + 8px);
    width: calc(var(--uic-scrollpanel-track-width) + 2 * var(--uic-scrollpanel-track-spacing));

    &::before {
      background-color: var(--uic-color-white);
      bottom: -8px;
      box-shadow: 0 0 6px 0 var(--uic-color-blue6a20);
      content: '';
      left: var(--uic-scrollpanel-track-spacing);
      position: absolute;
      right: var(--uic-scrollpanel-track-spacing);
      top: -8px;
    }
  }

  .simplebar-scrollbar {
    cursor: pointer;
  }

  .simplebar-scrollbar::before {
    background: var(--uic-scrollpanel-bar-color);
    bottom: 0;
    content: '';
    left: calc(50% - 1px);
    position: absolute;
    top: 0;
    width: 2px;
  }

  .simplebar-track.simplebar-horizontal .simplebar-scrollbar {
    bottom: 0;
    left: 0;
    min-height: 0;
    min-width: 10px;
    right: auto;
    top: 0;
    width: auto;
  }

  .simplebar-track {
    bottom: 0;
    overflow: hidden;
    pointer-events: none;
    position: absolute;
    right: 0;
    z-index: 1;
  }

  &[data-simplebar].simplebar-dragging .simplebar-track {
    pointer-events: all;
  }

  .simplebar-scrollbar {
    left: 0;
    min-height: 10px;
    position: absolute;
    right: 0;
  }

  &.simplebar-scrolling .simplebar-track,
  &.simplebar-hover .simplebar-track,
  &.simplebar-mouse-entered .simplebar-track {
    opacity: 1;
    transition-delay: 0s;
    transition-duration: 0s;
  }

  .simplebar-track:hover {
    /* When hovered, remove all transitions from drag handle */
    opacity: 1;
    transition-delay: 0s;
    transition-duration: 0s;
  }

  /* Rtl support */
  &[data-simplebar-direction='rtl'] .simplebar-track.simplebar-vertical {
    left: 0;
    right: auto;
  }
}

// SIMPLEBAR CSS

[data-simplebar] {
  align-content: flex-start;
  align-items: flex-start;
  flex-direction: column;
  flex-wrap: wrap;
  justify-content: flex-start;
  position: relative;
}

.simplebar-wrapper {
  height: inherit;
  max-height: inherit;
  max-width: inherit;
  overflow: hidden;
  width: inherit;
}

.simplebar-mask {
  bottom: 0;
  direction: inherit;
  height: auto !important;
  left: 0;
  margin: 0;
  overflow: hidden;
  padding: 0;
  position: absolute;
  right: 0;
  top: 0;
  width: auto !important;
  z-index: 0;
}

.simplebar-offset {
  bottom: 0;
  box-sizing: inherit !important;
  direction: inherit !important;
  left: 0;
  margin: 0;
  -webkit-overflow-scrolling: touch;
  padding: 0;
  position: absolute;
  resize: none !important;
  right: 0;
  top: 0;
}

.simplebar-content-wrapper {
  box-sizing: border-box !important;
  direction: inherit;
  display: block;
  height: 100%; /* Required for horizontal native scrollbar to not appear if parent is taller than natural height */
  max-height: 100%; /* Needed for vertical scroll to trigger */
  max-width: 100%; /* Not required for horizontal scroll to trigger */
  -ms-overflow-style: none;
  position: relative;
  scrollbar-width: none;
  width: auto;
}

.simplebar-content-wrapper::-webkit-scrollbar,
.simplebar-hide-scrollbar::-webkit-scrollbar {
  height: 0;
  width: 0;
}

.simplebar-content::before,
.simplebar-content::after {
  content: ' ';
  display: table;
}

.simplebar-placeholder {
  max-height: 100%;
  max-width: 100%;
  pointer-events: none;
  width: 100%;
}

.simplebar-height-auto-observer-wrapper {
  box-sizing: inherit !important;
  flex-basis: 0;
  flex-grow: inherit;
  flex-shrink: 0;
  float: left;
  height: 100%;
  margin: 0;
  max-height: 1px;
  max-width: 1px;
  overflow: hidden;
  padding: 0;
  pointer-events: none;
  position: relative;
  width: 100%;
  z-index: -1;
}

.simplebar-height-auto-observer {
  box-sizing: inherit;
  display: block;
  height: 1000%;
  left: 0;
  min-height: 1px;
  min-width: 1px;
  opacity: 0;
  overflow: hidden;
  pointer-events: none;
  position: absolute;
  top: 0;
  width: 1000%;
  z-index: -1;
}

[data-simplebar].simplebar-dragging .simplebar-content {
  pointer-events: none;
  -webkit-user-select: none;
  user-select: none;
}

.simplebar-track.simplebar-horizontal {
  height: 11px;
  left: 0;
}

.simplebar-dummy-scrollbar-size {
  direction: rtl;
  height: 500px;
  opacity: 0;
  -ms-overflow-style: scrollbar !important;
  overflow-x: scroll;
  overflow-y: hidden;
  position: fixed;
  visibility: hidden;
  width: 500px;
}

.simplebar-dummy-scrollbar-size > div {
  height: 200%;
  margin: 10px 0;
  width: 200%;
}

.simplebar-hide-scrollbar {
  left: 0;
  -ms-overflow-style: none;
  overflow-y: scroll;
  position: fixed;
  scrollbar-width: none;
  visibility: hidden;
}
